import { Toaster as Sonner } from 'sonner';

export function Toaster() {
  return (
    <Sonner
      position="top-right"
      expand={false}
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'bg-white border border-gray-200 shadow-lg',
          title: 'text-gray-900 font-medium',
          description: 'text-gray-600',
          actionButton: 'bg-smartfield-600 text-white',
          cancelButton: 'bg-gray-100 text-gray-900',
          closeButton: 'bg-white border-gray-200',
        },
      }}
    />
  );
}
